window.addEventListener('DOMContentLoaded', () => {

    let button = document.getElementById('show-more-posts');

    if (button) {
        button.addEventListener('click', handleLoadMore)
    }

    function handleLoadMore(e) {

        e.preventDefault();

        if (e.target.hasAttribute('data-page')) {
            loadMorePosts(e.target.getAttribute('data-page'))
        }

    }

    async function loadMorePosts(page) {

        const APIurl = `${restApi.url}custom/v1/posts/?page=${page}`;

        try {
            const response = await fetch(APIurl, {
                method: 'GET',
                headers: { 'X-WP-Nonce': restApi.nonce }
            });

            if (!response.ok) {
                throw new Error('Search failed');
            };

            const data = await response.json();

            // update button
            button.dataset.page = data.page;
            
            if(data.is_last_page){
                button.style.display = 'none';
            }

            let container = document.querySelector('.blog-posts');

            // https://developer.chrome.com/docs/web-platform/view-transitions

            if (!document.startViewTransition) {
                container.insertAdjacentHTML('beforeend', data.body);
                return;
            }

            document.startViewTransition(() => {
                container.insertAdjacentHTML('beforeend', data.body);
            });
            

        } catch (error) {
            console.error('Error:', error);
        }

    }

})

